import React from "react";
import Tooltip from '@mui/material/Tooltip';
import { connect } from "react-redux";
import CurrencyFormatter from "currency-formatter";
import { DESCENDANT_ORDER, YEARLY } from "../../../../config";

function Item({ label, tooltip = false, bold = false, dollar = false, percent = false, currentCompanyDupontRatios }) {

  let array = currentCompanyDupontRatios ?
    currentCompanyDupontRatios[currentCompanyDupontRatios.prefix + label.replace(/ /g, "")]
    ?.filter((value, index) => index >= (currentCompanyDupontRatios.prefix === YEARLY ? 0 : 11)) :
    [];
  if(currentCompanyDupontRatios?.dateOrder == DESCENDANT_ORDER) array = array?.slice().reverse();
      //we must reverse the array if dateOrder is descendant order because data in Dupont ratio store is date ascendant

  return (
    <div className="flex items-center mt-3">
      <div
        className={
          bold
            ? "whitespace-nowrap flex items-center pt-4 pb-2 font-semibold border-t"
            : "whitespace-nowrap flex items-center pt-2"
        }
        style={{ minWidth: "18em" }}
      >
        {tooltip ? <Tooltip title = {tooltip} arrow>{label}</Tooltip> : label}
      </div>
      <div
        className={
          bold
            ? "flex pt-4 pb-2 font-semibold border-t"
            : "flex pt-2"
        }
      >
        {array?.map((obj) => (
          <div className={obj.disabled? "disabled flex" : "flex"} style={{ minWidth: "10em" }}>
            <div style={{ minWidth: "0.5em" }} />
            {CurrencyFormatter.format(percent ? obj.value * 100 : obj.value, {
              code: dollar ? "USD" : "",
            })}
            {percent ? "%" : ""}
          </div>
        ))}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  currentCompanyDupontRatios: state.financialRatios.currentCompanyDupontRatios
});

export default connect(mapStateToProps)(Item);
